export default "__VITE_ASSET__Btksss3K__"